<template>
    <p>selecting path...</p>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
    computed: {
        ...mapGetters({
            params: 'settings/get',
        }),
    },
    created() {
        this.$router.push({
            name: this.params.uvid !== undefined && this.params.uvid !== null
                ? 'Rental'
                : 'Pack',
        })
    },
}
</script>
